import setOpen from './set-open';
import setDisplayMode from './set-display-mode';

export default {
  setOpen,
  setDisplayMode,
};
